/* SOFT SKILLS ABILITIES USERS */
export const ALL_SOFTSKILLS_ABILITIES_USERS = "ALL_SOFTSKILLS_ABILITIES_USERS"
export const ALL_SOFTSKILLS_ABILITIES_USERS_SUCCESS =
  "ALL_SOFTSKILLS_ABILITIES_USERS_SUCCESS"
export const ALL_SOFTSKILLS_ABILITIES_USERS_ERROR =
  "ALL_SOFTSKILLS_ABILITIES_USERS_ERROR"
